
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectInfiniteScrollModule } from "ng-mat-select-infinite-scroll";
import { NgxDateRangeModule } from "ngx-daterange";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ControlRequiredPipe } from "src/app/pipes/controlRequired/control-required.pipe";
import { MaterialModule } from "../material/material.module";
import { CommonConfirmDialogComponent } from "./common-confirm-dialog/common-confirm-dialog.component";
//import { ColumnsChartComponent } from "./components/columns-chart/columns-chart.component";
//import { PieChartComponent } from "./components/pie-chart/pie-chart.component";
import { CustomErrorPageComponent } from "./custom-error-page/custom-error-page.component";
import { DropdownInputTypeComponent } from "./dropdown-input-type/dropdown-input-type.component";
import { SnackbarComponent } from "./snackbar/snackbar.component";
import { ImageUploadWithCropperComponent } from './image-upload-with-cropper/image-upload-with-cropper.component';
import { ShowImageComponent } from './image-upload-with-cropper/show-image/show-image.component';

@NgModule({
  declarations: [
    SnackbarComponent,
    CustomErrorPageComponent,
    CommonConfirmDialogComponent,
    DropdownInputTypeComponent,
    ControlRequiredPipe,
 //   PieChartComponent,
  //  ColumnsChartComponent,
    ImageUploadWithCropperComponent,
    ShowImageComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxDateRangeModule,
    NgxMatSelectSearchModule,
    MatSelectInfiniteScrollModule,
    NgxDaterangepickerMd,
    ImageCropperModule

  ],
  exports: [
    CustomErrorPageComponent,
    DropdownInputTypeComponent,
    //PieChartComponent,
  //  ColumnsChartComponent,
    ImageUploadWithCropperComponent
  ]
})
export class UtilsModule { }
